import React from 'react';
import { Box, Combobox, ComboboxProps, FormError } from 'pounceV2';
import { FieldConfig } from 'formik';
import useFastField from 'Hooks/useFastField';
import useEventHandler from 'Hooks/useEventHandler';
import { safeguardErrorMsg } from '../utils';

function FormikComboboxV3<T>(
  props: ComboboxProps<T> &
    Required<Pick<FieldConfig, 'name'>> & { overrideOnChange?: (value: T[]) => void },
): React.ReactNode {
  const { name, ...rest } = props;

  const [, meta, { setValue }] = useFastField(name);

  const handleChange = useEventHandler(e => {
    if (props.overrideOnChange) {
      props.overrideOnChange(e);
    } else {
      setValue(e);
    }
  });

  const isInvalid = meta.touched && !!meta.error;
  const errorElementId = isInvalid ? `${name}-error` : undefined;

  return (
    <Box>
      <Combobox
        {...rest}
        onChange={handleChange}
        invalid={isInvalid}
        aria-describedby={isInvalid ? errorElementId : undefined}
      />
      {isInvalid && (
        <FormError mt={2} id={errorElementId}>
          {safeguardErrorMsg(meta.error)}
        </FormError>
      )}
    </Box>
  );
}

export default FormikComboboxV3;
